import { defineComponent as _defineComponent } from 'vue'
import { shiftApi } from '@/api';
import Button from '@/components/buttons/Button.vue';
import ActionDialog from '@/components/dialog/ActionDialog.vue';
import Dialog from '@/components/dialog/Dialog.vue';
import InputGroup from '@/components/form/InputGroup.vue';
import NumberInput from '@/components/inputs/NumberInput.vue';
import LoadingOverlay from '@/components/loaders/LoadingOverlay.vue';
import i18n from '@/i18n';
import { useOpen } from '@/lib/composition/dialog';
import { Icon } from '@/lib/enum/Icon';
import { Entity } from '@/lib/realtime/RealtimeEntity';
import { realtimeQuery } from '@/lib/realtime/weak/realtimeFunctions';
import {
  isOpenAndUnassigned,
  isPublished,
} from '@/lib/schedule-v2/shiftV2Status';
import { showSuccess } from '@/plugins/ToastNotifications';
import {
  getErrorMessages,
  maxValue,
  minValue,
  required,
} from '@/plugins/vuelidate';
import { viewport } from '@/util/windowFunctions';
import ShiftSummary from '@/views/schedule/components/ShiftSummary.vue';
import useVuelidate from '@vuelidate/core';
import { computed, onMounted, reactive, ref } from 'vue';
import {
  OpenShiftResponse,
  OpenShiftResponseStatusEnum,
  Shift,
} from '../../../../api/v1';
import ShiftDialogHeader from './components/ShiftDialogHeader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ToggleOpenShift',
  props: {
    value: { type: Boolean },
    shift: null,
    matchingShiftIds: { default: () => [] }
  },
  emits: ["input", "close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: boolean, shift: Shift, matchingShiftIds: number[] }





const loading = ref(false);

const showDialog = ref<boolean>(false);

const form = reactive<{ quantity: number }>({
  quantity: props.matchingShiftIds.length + 1,
});
const validations = {
  quantity: {
    required,
    minValue: minValue(1),
    maxValue: maxValue(props.matchingShiftIds.length + 1),
  },
};
const v$ = useVuelidate(validations, form, { $autoDirty: true });

const open = useOpen(() => props.value, emit);

const confirmMoveToUnassigned = ref<null | Function>(null);

const selectedShiftIds = computed<Shift['id'][]>(() => {
  return [
    props.shift.id,
    ...props.matchingShiftIds.slice(0, form.quantity - 1),
  ];
});

const openShiftResponses = realtimeQuery(Entity.OpenShiftResponse)
  .whereIn('shiftId', [props.shift.id, ...props.matchingShiftIds])
  .fetch();

const filteredOpenShiftResponses = computed<OpenShiftResponse[]>(() => {
  return openShiftResponses.data.filter(
    (r) =>
      selectedShiftIds.value.includes(r.shiftId) &&
      r.status !== OpenShiftResponseStatusEnum.Rejected,
  );
});

const toggleOpenShift = () => {
  loading.value = true;
  const toggleShiftOpen = () => {
    if (form.quantity === 1) {
      shiftApi
        .updateShift({
          id: props.shift.id,
          updateShiftData: {
            open: !props.shift.open,
            published: false,
          },
        })
        .then(({ data: updatedShift }) => {
          const successMessage = isOpenAndUnassigned(updatedShift)
            ? i18n.tc('schedule.movedToOpenShifts')
            : i18n.tc('schedule.movedToUnassigned');
          showSuccess(successMessage);
          open.value = false;
        })
        .finally(() => {
          confirmMoveToUnassigned.value = null;
          loading.value = false;
        });
    } else {
      shiftApi
        .bulkUpdateShifts({
          bulkUpdateShiftsData: {
            baseData: {
              open: !props.shift.open,
            },
            shiftData: [
              {
                shiftIds: selectedShiftIds.value,
                data: {},
              },
            ],
          },
        })
        .then(() => {
          const successMessage = !isOpenAndUnassigned(props.shift)
            ? i18n.tc('schedule.movedToOpenShifts')
            : i18n.tc('schedule.movedToUnassigned');
          showSuccess(successMessage);
          open.value = false;
        })
        .finally(() => {
          loading.value = false;
        });
    }
  };

  if (isOpenAndUnassigned(props.shift) && isPublished(props.shift)) {
    confirmMoveToUnassigned.value = toggleShiftOpen;
  } else {
    toggleShiftOpen();
  }
};

onMounted(() => {
  if (!props.matchingShiftIds.length) {
    return toggleOpenShift();
  }
  showDialog.value = true;
});

return { __sfc: true,props, emit, loading, showDialog, form, validations, v$, open, confirmMoveToUnassigned, selectedShiftIds, openShiftResponses, filteredOpenShiftResponses, toggleOpenShift, Button, ActionDialog, Dialog, InputGroup, NumberInput, LoadingOverlay, Icon, getErrorMessages, viewport, ShiftSummary, ShiftDialogHeader }
}

})